<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getAiAnswersLink('queries')" :class="{active: currentReport === 'ai-answers'}">
            <span>{{ $t('lang.menu.search.ai_answers.queries') }}</span>
        </a>
        <a :href="getAiAnswersLink('concurents')" :class="{active: currentReport === 'aiconcurents'}">
            <span>{{ $t('lang.menu.search.ai_answers.concurents') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Submenu from "../mixins/Submenu";
import moment from "moment";

export default {
    name: "MenuSubmenuAiAnswers",
    mixins: [Submenu],
    props: {
        domain: {
            type: String,
            required: true,
        },
        dbname: {
            type: String,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            listenerId: Listeners.TOP_MENU_AI_ANSWERS_HOVER,
        };
    },
    methods: {
        getAiAnswersLink(type) {
            if (type === 'queries') {
                const startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
                const endDate = moment().format('YYYY-MM-DD');
                const dbParam = this.dbname ? `&db=${this.dbname}` : '';
                return sprintf(
                    '/%s/ai-answers?domain=%s%s#filter=created_atBETWEEN%s%%40%s',
                    window.locale,
                    this.domain,
                    dbParam,
                    startDate,
                    endDate
                );
            } else if (type === 'concurents') {
                const startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
                const endDate = moment().format('YYYY-MM-DD');
                const dbParam = this.dbname ? `&db=${this.dbname}` : '';
                return sprintf(
                    '/%s/aiconcurents?domain=%s%s#filter=created_atBETWEEN%s%%40%s',
                    window.locale,
                    this.domain,
                    dbParam,
                    startDate,
                    endDate
                );
            }
            return sprintf('/%s/ai-answers?domain=%s', window.locale, this.domain);
        },
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
